module.exports = __webpack_public_path__ + "static/media/Week12.f772716e.pdf";